import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { Button, Grid } from "antd";
import { observer } from "mobx-react-lite";

import { userStore } from "../../../stores/userStore";
import { sendCounterEvent } from "../../../utils/counterService";

import "./CreateWebgisButton.css";

const { useBreakpoint } = Grid;

export const CreateWebgisButton = observer(function CreateWebgisButton() {
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const location = useLocation();

  const showCreateWebgis = userStore.webgisLoaded && userStore.webgis === null;
  const onWebgisPage = location.pathname.startsWith("/webgis");

  if (!showCreateWebgis || !screens.md) {
    return null;
  }

  return (
    <div className="create-webgis-btn">
      {onWebgisPage ? (
        <Button
          type="primary"
          size="large"
          onClick={() => sendCounterEvent("header_create_webgis")}
        >
          {t("webgis.create")}
        </Button>
      ) : (
        <Link
          to="/webgis"
          className="nolink"
          onClick={() => sendCounterEvent("header_create_webgis")}
        >
          <Button type="primary" size="large">
            {t("webgis.create")}
          </Button>
        </Link>
      )}
    </div>
  );
});
